export default __webpack_public_path__ + "static/media/dashboaard-colored.55770e0e.svg";